const jwtToken = 'jwtToken';
const encryptionKey = 'encryptionKey';

const getItemFromLocalStorage = (itemId: string) => localStorage.getItem(itemId);

const removeItemFromLocalStorage = (itemId: string) => localStorage.removeItem(itemId);

const addItemToLocalStorage = (token: string, itemId: string) => localStorage.setItem(token, itemId);

const getJwtToken = (): string | null => getItemFromLocalStorage(jwtToken);

const setJwtToken = (token: string) => addItemToLocalStorage(jwtToken, token);

const removeJwtToken = () => {
  removeItemFromLocalStorage(jwtToken);
  removeItemFromLocalStorage(encryptionKey);
};

const getEncryptionKey = (): string | null => getItemFromLocalStorage(encryptionKey);

const setEncryptionKey = (token: string) => addItemToLocalStorage(encryptionKey, token);

const localStorageAccess = {
  getJwtToken,
  setJwtToken,
  removeJwtToken,
  getEncryptionKey,
  setEncryptionKey,
};

export default localStorageAccess;
